import React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab, faSalesforce } from "@fortawesome/free-brands-svg-icons";
import {
  faCheck,
  faTimes,
  faPlus,
  faSave,
  faWindowClose,
  faHandHoldingUsd,
  faArrowCircleLeft,
  faStop,
  faMinus,
  faWindowMaximize,
  faWindowMinimize,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faFilePdf,
  faFileExcel,
  faGlasses,
  faChartBar,
  faPlayCircle,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faThumbsUp,
  faSearch,
  faUndoAlt,
  faUndo,
  faEraser,
  faImage,
  faTrash,
  faCamera,
  faFileUpload,
  faMoneyBill,
  faCreditCard,
  faMoneyCheckAlt,
  faMoneyBillAlt,
  faColumns,
  faEdit,
  faPlusCircle,
  faTicketAlt,
  faThumbsDown,
  faExchangeAlt,
  faRedo,
  faFilter,
  faUsers,
  faNewspaper,
  faPaintRoller,
  faAdjust,
  faBarcode,
  faPenSquare,
  faHistory,
  faReceipt,
  faInfo,
  faFileInvoice,
  faTruckLoading,
  faTimesCircle,
  faUserAltSlash,
  faHandHoldingWater,
  faIdCard,
  faArrowAltCircleUp,
  faArrowsAltH,
  faClipboardCheck,
  faClipboard,
  faFire,
  faFlag,
  faCalendarAlt,
  faPrint,
  faThLarge,
  faTape,
  faClipboardList,
  faMailBulk,
  faCalendarWeek,
  faCartPlus,
  faCampground,
  faMoneyBillWave,
  faObjectGroup,
  faObjectUngroup,
  faHandRock,
  faUserPlus,
  faAlignCenter,
  faArrowAltCircleRight,
  faChalkboardTeacher,
  faArrowsAltV,
  faSpider,
  faSpinner,
  faNetworkWired,
  faTasks,
  faSuitcaseRolling,
  faSuitcase,
  faDoorOpen,
  faBookReader,
  faMoneyCheck,
  faLuggageCart,
  faVoicemail,
  faCaretUp,
  faCaretDown,
  faEye,
  faEyeDropper,
  faEyeSlash,
  faChild,
  faHandshake,
  faUserCircle,
  faCalculator,
  faGlobe,
  faHandPaper,
  faGifts,
  faHouseUser,
  faGift,
  faFileInvoiceDollar,
  faStickyNote,
  faBook, 
  faCommentDollar,
  faMoneyBillWaveAlt,
  faTerminal,
  faLockOpen,
  faLock,
  faSearchDollar,
  faInfoCircle,
  faKey,
  faBoxOpen,
  faBookOpen
  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VscSave } from "react-icons/vsc";
import { RiRefreshLine } from "react-icons/ri";
import { FiRefreshCcw } from "react-icons/fi";
import {
  FaListUl,
  FaFilePdf,
  FaFileExcel,
  FaThumbsUp,
  FaThumbsDown,
  FaMinusCircle,
} from "react-icons/fa";
import { MdExitToApp, MdClose } from "react-icons/md";
import { BiBlock, BiUser, BiError } from "react-icons/bi";
import { BsReverseLayoutTextWindowReverse } from "react-icons/bs";
import { HiMailOpen } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";
import { FiSearch, FiCheckCircle } from "react-icons/fi";

library.add(
  fab,
  faCheck,
  faTimes,
  faPlus,
  faSave,
  faWindowClose,
  faHandHoldingUsd,
  faArrowCircleLeft,
  faStop,
  faWindowMaximize,
  faWindowMinimize,
  faMinus,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faFilePdf,
  faFileExcel,
  faGlasses,
  faChartBar,
  faPlayCircle,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faThumbsUp,
  faSearch,
  faImage,
  faTrash,
  faCamera,
  faFileUpload,
  faMoneyBill,
  faCreditCard,
  faMoneyCheckAlt,
  faNewspaper,
  faPaintRoller,
  faAdjust,
  faBarcode,
  faPenSquare,
  faHistory,
  faReceipt,
  faInfo,
  faFileInvoice,
  faTruckLoading,
  faTimesCircle,
  faUserAltSlash,
  faIdCard,
  faHandHoldingWater,
  faArrowAltCircleUp,
  faArrowsAltH,
  faClipboardCheck,
  faClipboard,
  faMoneyBillAlt,
  faColumns,
  faEdit,
  faTicketAlt,
  faExchangeAlt,
  faRedo,
  faFilter,
  faUsers,
  faCommentDollar,
  
  faChild,
  faHandshake,
  faUserCircle,
  faCalculator,
  faGlobe,
  faGifts,
  faHouseUser,
  faGift,
  faFileInvoiceDollar,
  faStickyNote,
  faBook, 
  


  faFlag,
  faFire,
  faCalendarAlt,
  faPrint,
  faThLarge,
  faTape,
  faClipboardList,
  faMailBulk,
  faCalendarWeek,
  faCartPlus,
  faCampground,
  faMoneyBillWave,
  faObjectGroup,
  faObjectUngroup,
  faHandRock,
  faUserPlus,
  faAlignCenter,
  faArrowAltCircleRight,
  faChalkboardTeacher,
  faArrowsAltV,
  faSpider,
  faSpinner,
  faNetworkWired,
  faTasks,
  faDoorOpen,
  faSuitcaseRolling,
  faLock,
  faLockOpen,
  faSuitcase,
  faBookReader,
  faMoneyCheck,
  faLuggageCart,
  faVoicemail,
  faCaretUp,
  faCaretDown,
  faEye,
  faEyeDropper,
  faEyeSlash,
  faKey,
  faBoxOpen ,
  faBookOpen

);
// import { BsSave } from "react-icons/bs";
// import { MdSaveAs } from "react-icons/md";

export const CloseIcon = () => <FontAwesomeIcon icon="window-close" />;
export const CheckIcon = () => <FontAwesomeIcon icon="check-square" />;
export const SaveIcon = () => <FontAwesomeIcon icon="save" />;
export const BackIcon = () => <FontAwesomeIcon icon="arrow-circle-left" />;
export const AddIcon = () => <FontAwesomeIcon icon="plus" />;
export const ExitIcon = () => <FontAwesomeIcon icon="stop" />;
export const ApproveIcon = () => <FontAwesomeIcon icon="thumbs-up" />;
export const CancelIcon = () => <FontAwesomeIcon icon="times" />;
export const PayIcon = () => <FontAwesomeIcon icon="money" />;
export const NoImageIcon = () => <FontAwesomeIcon icon={faImage} />;
export const SearchImageIcon = () => <FontAwesomeIcon icon="search" />;
export const SampleRollIcon = () => (
  <FontAwesomeIcon icon={faBoxOpen} />
);
export const CollapseMaximizeIcon = () => (
  <FontAwesomeIcon
    icon={faWindowMaximize}
    size="xs"
    className="custom_collapsable_icon"
  />
);
export const CollapseMinimizeIcon = () => (
  <FontAwesomeIcon
    icon={faWindowMinimize}
    size="xs"
    className="custom_collapsable_icon"
  />
);
export const AngleDoubleDownIcon = () => (
  <FontAwesomeIcon icon={faAngleDoubleDown} />
);
export const AngleDoubleUpIcon = () => (
  <FontAwesomeIcon icon={faAngleDoubleUp} />
);
export const AngleDoubleLeftIcon = () => (
  <FontAwesomeIcon icon={faAngleDoubleLeft} />
);
export const AngleDoubleRightIcon = () => (
  <FontAwesomeIcon icon={faAngleDoubleRight} />
);
export const PDFIcon = () => <FontAwesomeIcon icon={faFilePdf} />;
export const ExcelIcon = () => <FontAwesomeIcon icon={faFileExcel} />;
export const PlayIcon = () => <FontAwesomeIcon icon={faPlayCircle} />;
export const ChevronCircleDown = () => (
  <FontAwesomeIcon icon={faChevronCircleDown} />
);
export const ChevronCircleUp = () => (
  <FontAwesomeIcon icon={faChevronCircleUp} />
);
export const ChevronLeft = () => <FontAwesomeIcon icon={faChevronLeft} />;
export const ChevronRight = () => <FontAwesomeIcon icon={faChevronRight} />;
export const UndoAlt = () => <FontAwesomeIcon icon={faUndoAlt} />;
export const Undo = () => <FontAwesomeIcon icon={faUndo} />;
export const Eraser = () => <FontAwesomeIcon icon={faEraser} />;
export const DeleteIcon = () => <FontAwesomeIcon icon={faTrash} />;
export const CameraIcon = () => <FontAwesomeIcon icon={faCamera} />;
export const UploadDocIcon = () => <FontAwesomeIcon icon={faFileUpload} />;
export const CashIcon = () => (
  <div className="cashIcon">
    <div>
      <FontAwesomeIcon icon={faMoneyBillAlt} size="5x" title={"Cash"} />
    </div>
    <span> Cash </span>
  </div>
);
export const CardIcon = () => (
  <div className="cardIcon">
    <div>
      <FontAwesomeIcon icon={faCreditCard} size="5x" title={"Card"} />
    </div>
    <span> Card </span>
  </div>
);
export const MoneyCheckIcon = () => (
  <div className="checkIcon">
    <div>
      <FontAwesomeIcon icon={faMoneyCheckAlt} size="5x" title={"Check"} />
    </div>
    <span> Check </span>
  </div>
);
export const SplitIcon = () => (
  <div className="splitIcon">
    <div>
      <FontAwesomeIcon icon={faColumns} size="5x" title={"Split"} />
    </div>
    <span> Split </span>
  </div>
);
export const UnApproveIcon = () => <FontAwesomeIcon icon={faThumbsDown} />;
export const EditIcon = () => <FontAwesomeIcon icon={faEdit} />;
export const TicketIcon = () => <FontAwesomeIcon icon={faTicketAlt} />;
export const SearchIcon = () => <FontAwesomeIcon icon={faSearch} />;
export const SwapIcon = () => <FontAwesomeIcon icon={faExchangeAlt} />;
export const RefreshIcon = () => <FontAwesomeIcon icon={faRedo} />;
export const FilterIcon = () => <FontAwesomeIcon icon={faFilter} />;
//Changed
export const AttributesGeneralIcon = () => <FontAwesomeIcon icon={faUsers} />;
export const AttributesCustomerIcon = () => <FontAwesomeIcon icon={faChild} />;
export const AttributesVendorIcon = () => <FontAwesomeIcon icon={faHandshake} />;
export const AttributesProductionIcon = () => <FontAwesomeIcon icon={faUserCircle} />;
export const AttributesAccountingIcon = () => <FontAwesomeIcon icon={faCalculator} />;
export const AttributesWebIcon = () => <FontAwesomeIcon icon={faGlobe}/>;
export const AttributesItemIcon = () => <FontAwesomeIcon icon={faGifts}/>;
export const MasterItemIcon = () => <FontAwesomeIcon icon={faGift}/>;
export const MasterCustomerIcon = () => <FontAwesomeIcon icon={faChild} />;
export const MasterVendorIcon = () => <FontAwesomeIcon icon={faHandshake} />;
export const MasterItemCostIcon = () => <FontAwesomeIcon icon={faFileInvoiceDollar} />;
export const SalesSalesOrderIcon = () => <FontAwesomeIcon icon={faStickyNote} />;
export const SalesMassSalesOrderIcon = () => <FontAwesomeIcon icon={faBook} />
export const SalesPickTicketIcon = () => <FontAwesomeIcon icon={faTicketAlt} />
export const SalesInvoiceIcon = () => <FontAwesomeIcon icon = {faMoneyBill} />
export const SalesCommisionMaintenanceIcon = () => <FontAwesomeIcon icon ={faCommentDollar}/>
export const SalesPrintBulkPickTicketIcon = () => <FontAwesomeIcon icon = {faPrint} />
export const SalesMassSalesOrderPrintIcon = () => <FontAwesomeIcon icon = {faThLarge} />
export const SalesPickTicketRollEntityIcon = () => <FontAwesomeIcon icon = {faTape} />
export const SalesCommercialInvoiceForMultipleInvoiceIcon = () => <FontAwesomeIcon icon = {faClipboardList} />
export const SalesAdvancedMassOrderPickticketIcon = () => <FontAwesomeIcon icon = {faVoicemail} />
export const SalesInvoiceForMultipleInvoiceIcon = () => <FontAwesomeIcon icon = {faMailBulk} />
export const SalesMailInvoicesIcon = () => <FontAwesomeIcon icon = {faMoneyBillWave} />
export const SalesSalesMassMaintenanceIcon = () => <FontAwesomeIcon icon = {faObjectGroup} />
export const CPMPreProductionMaintenanceIcon = () => <FontAwesomeIcon icon = {faHandRock} />
export const CPMEntryMaintenanceIcon = () => <FontAwesomeIcon icon = {faDoorOpen} />
export const CPMReportIcon = () => <FontAwesomeIcon icon = {faBookReader} />
export const PurchaseOrderIcon = () => <FontAwesomeIcon icon = {faLuggageCart} />
export const PurchaseMassPurchaseOrderPrintIcon = () => <FontAwesomeIcon icon = {faMoneyCheckAlt} />
export const PurchaseMassPurchaseOrderCancelIcon = () => <FontAwesomeIcon icon = {faWindowClose} />
export const PurchaseIntransitIcon = () => <FontAwesomeIcon icon = {faHandHoldingUsd} />
export const PurchaseOrderReceiptIcon = () => <FontAwesomeIcon icon = {faMoneyCheck} />
export const PurchaseVendorInvoiceIcon = () => <FontAwesomeIcon icon = {faNewspaper} />
export const AccountsReceivableIcon = () => <FontAwesomeIcon icon = {faClipboard} />
export const AccountsCreditMemoIcon = () => <FontAwesomeIcon icon = {faClipboardCheck} />
export const AccountsCheckTransitionIcon = () => <FontAwesomeIcon icon = {faCheck} />
export const AccountsBatchCheckTransitionIcon = () => <FontAwesomeIcon icon = {faArrowAltCircleUp} />
export const AccountsBankAdjustmentIcon = () => <FontAwesomeIcon icon = {faArrowsAltH} />
export const AccountsDepositIcon = () => <FontAwesomeIcon icon = {faHandHoldingWater} />
export const AccountsLetterOfCreditIcon = () => <FontAwesomeIcon icon = {faIdCard} />
export const AccountsCheckBounceIcon = () => <FontAwesomeIcon icon = {faMoneyCheck}/>
export const AccountsCustomerReturnIcon = () => <FontAwesomeIcon icon = {faUserAltSlash} />
export const AccountsPostDatedCheckEntryIcon = () => <FontAwesomeIcon icon = {faStickyNote} />
export const InboundOrderIcon = () => <FontAwesomeIcon icon = {faTruckLoading} />
export const InboundReceiptIcon = () => <FontAwesomeIcon icon = {faReceipt} />
export const InboundBarcodeIcon = () => <FontAwesomeIcon icon = {faBarcode} />
export const InventoryAdjustmentIcon = () => <FontAwesomeIcon icon = {faAdjust} />
export const InventoryTransferIcon = () => <FontAwesomeIcon icon = {faExchangeAlt}/>
export const InventoryPrintRollIcon = () => <FontAwesomeIcon icon = {faPaintRoller} />
export const InventoryPrintPOIntransitRollIcon = () => <FontAwesomeIcon icon = {faObjectUngroup} />
export const InventoryMassInventoryTransferIcon = () => <FontAwesomeIcon icon = {faUserPlus} />
export const InventoryPhysicalInvAdjustmentsIcon = () => <FontAwesomeIcon icon = {faAlignCenter} />
export const InventoryRollInventoryMainteranceIcon = () => <FontAwesomeIcon icon = {faArrowAltCircleRight} />
export const InventoryManualInventoryAllocationIcon = () => <FontAwesomeIcon icon = {faChalkboardTeacher} />
export const InventoryRollDataConversionIcon = () => <FontAwesomeIcon icon = {faArrowsAltV} />
export const JobWebItemExportIcon = () => <FontAwesomeIcon icon = {faSpider}/>
export const JobWebItemImportIcon = () => <FontAwesomeIcon icon = {faSpinner} />
export const JobWebSKUInventoryReprortIcon = () => <FontAwesomeIcon icon = {faNetworkWired} />
export const JobEcommJobStatusIcon = () => <FontAwesomeIcon icon = {faTasks} />
export const JobEcommWebOrderStatusIcon = () => <FontAwesomeIcon icon = {faTerminal} />
export const JobWebItemExcelToERPImportIcon = () => <FontAwesomeIcon icon = {faFileExcel} />

export const InquiryAllItemATSIcon = () => <FontAwesomeIcon icon = {faGlasses} />
export const InquiryItemStatisticsIcon = () => <FontAwesomeIcon icon = {faChartBar} />
export const InquiryPrintoutTrackInquiryIcon = () => <FontAwesomeIcon icon = {faPrint} />
export const InquiryItemListWithPriceAndCostIcon = () => <FontAwesomeIcon icon = {faClipboardList} />
export const InquiryAllItemCustomInquiryIcon = () => <FontAwesomeIcon icon = {faGifts} />
export const InquiryCustomerItemATSInquiryIcon = () => <FontAwesomeIcon icon={faHouseUser} />
export const InquiryMailTrackIcon = () => <FontAwesomeIcon icon ={faMailBulk} />
export const InquiryItemWeeklyMonthlyATSIcon = () => <FontAwesomeIcon icon = {faCalendarWeek} />
export const InquiryOnOrderIcon = () => <FontAwesomeIcon icon = {faCartPlus} />
export const InquiryCPMIcon = () => <FontAwesomeIcon icon = {faCampground} />
export const InquirySalesIcon = () =><FontAwesomeIcon icon = {faCommentDollar} />
export const InquiryInboundIcon = () => <FontAwesomeIcon icon = {faReceipt} />
export const InquiryInfoIcon = () => <FontAwesomeIcon icon = {faInfoCircle} />
export const InquiryInventoryIcon = () => <FontAwesomeIcon icon = {faFileInvoice} />
export const InquirySalesAnaysisIcon = () =><FontAwesomeIcon icon = {faSearchDollar} />
export const InquiryPurchaseIcon = () => <FontAwesomeIcon icon = {faMoneyCheckAlt} />
export const InquiryStatisticsIcon = () => <FontAwesomeIcon icon = {faBarcode} />
export const InquiryAccountsIcon = () => <FontAwesomeIcon icon = {faPenSquare} />
export const InquiryPaymentHistoryIcon = () => <FontAwesomeIcon icon = {faHistory} />

export const FabricCatalogGenerationIcon = () => (
  <FontAwesomeIcon icon={faBookOpen} />
);

export const SecurityUserMaintenanceIcon = () => <FontAwesomeIcon icon = {faSuitcaseRolling} />
export const SecurityRoleMaintenanceIcon = () => <FontAwesomeIcon icon = {faSuitcase} />
export const SystemReleaseLockIcon = () => <FontAwesomeIcon icon = {faLock} />
export const SystemRefreshCacheIcon = () => <FontAwesomeIcon icon = {faLockOpen} />

//end
export const CalendarIcon = () => <FontAwesomeIcon icon={faCalendarAlt} />;
export const PrintIcon = () => <FontAwesomeIcon icon={faPrint} />;
export const TickIcon = () => <FontAwesomeIcon icon={faCheck} />;
export const DropDwnUp = () => <FontAwesomeIcon icon={faCaretUp} />;
export const DropDwnDown = () => <FontAwesomeIcon icon={faCaretDown} />;
export const FaEye = () => <FontAwesomeIcon icon={faEye} />;
export const FaEyeOpner = () => <FontAwesomeIcon icon={faEyeDropper} />;
export const FaEyeSlash = () => <FontAwesomeIcon icon={faEyeSlash} />;

export const Authentication = () => <FontAwesomeIcon icon={faKey} />

export const ChartIcon = () => <FontAwesomeIcon icon={faChartBar} />
export const AnalyticsIcon = () =><FontAwesomeIcon icon="fa-sharp fa-solid fa-eye" />

export const SAVEICON = () => {
  return <VscSave />;
};
export const EXITICON = () => {
  // return <IoMdClose />;
  return <MdExitToApp />;
};
export const RESETICON = () => {
  return <FiRefreshCcw />;
};
export const CLEARICON = () => {
  return <BiBlock />;
};
export const LISTICON = () => {
  return <FaListUl />;
};
export const PDFICON = () => {
  return <FaFilePdf />;
};
export const EXCELICON = () => {
  return <FaFileExcel />;
};
export const USERICON = () => {
  return <BiUser />;
};
export const NEWENTRYICON = () => {
  return <BsReverseLayoutTextWindowReverse />;
};
export const APPROVEICON = () => {
  return <FaThumbsUp />;
};
export const UNAPPROVEICON = () => {
  return <FaThumbsDown />;
};
export const CANCELICON = () => {
  return <FaMinusCircle />;
};
export const MAILICON = () => {
  return <HiMailOpen />;
};
export const SEARCHICON = () => {
  return <FiSearch />;
};
export const REFRESHICON = () => {
  return <RiRefreshLine />;
};


export const ERRORICON = () => {
  return <BiError />;
};
export const SUCCESSICON = () => {
  return <FiCheckCircle />;
};
export const CLOSEICON = () => {
  return <MdClose />;
};
